const CLAIM_COUPON_REQUEST = 'CLAIM_CLAIM_COUPON_REQUEST'
const CLAIM_COUPON_SUCCESS = 'CLAIM_CLAIM_COUPON_SUCCESS'
const CLAIM_COUPON_FAILURE = 'CLAIM_CLAIM_COUPON_FAILURE'
const CLAIM_TOKEN_REQUEST = 'CLAIM_CLAIM_TOKEN_REQUEST'
const CLAIM_TOKEN_SUCCESS = 'CLAIM_CLAIM_TOKEN_SUCCESS'
const CLAIM_TOKEN_FAILURE = 'CLAIM_CLAIM_TOKEN_FAILURE'
const ADD_SELECTED_CONTENT = 'CLAIM_ADD_SELECTED_CONTENT'
const ADD_SELECTED_CONTENT_FAILURE = 'CLAIM_ADD_SELECTED_CONTENT_FAILURE'
const ADD_SURVEY = 'CLAIM_ADD_SURVEY'
const REMOVE_SELECTED_CONTENT = 'CLAIM_REMOVE_SELECTED_CONTENT'
const GET_PROMOTION_REQUEST = 'CLAIM_GET_PROMOTION_REQUEST'
const GET_PROMOTION_SUCCESS = 'CLAIM_GET_PROMOTION_SUCCESS'
const GET_PROMOTION_FAILURE = 'CLAIM_GET_PROMOTION_FAILURE'
const GET_SURVEY_REQUEST = 'CLAIM_GET_SURVEY_REQUEST'
const GET_SURVEY_SUCCESS = 'CLAIM_GET_SURVEY_SUCCESS'
const GET_SURVEY_FAILURE = 'CLAIM_GET_SURVEY_FAILURE'
const SET_ACTIVE_PROMOTION_STEP = 'CLAIM_SET_ACTIVE_PROMOTION_STEP'
const PREVIOUS_CLAIM_STATE = 'CLAIM_PREVIOUS_CLAIM_STATE'
const NEXT_CLAIM_STATE = 'CLAIM_NEXT_CLAIM_STATE'
const CLAIM_SUCCESS = 'CLAIM_SUCCESS'
const CLAIM_FAILURE = 'CLAIM_FAILURE'
const CLEAR_REDEEM_STATE = 'CLEAR_STATE'
const TOGGLE_CONFIRM = 'TOGGLE_CONFIRM'
const SET_SELECT_STATE = 'SET_SELECT_STATE'
const CLAIM_COUPON_PROOF_REQUIRED = 'CLAIM_COUPON_PROOF_REQUIRED'
const CLAIM_TOKEN_PROOF_REQUIRED = 'CLAIM_TOKEN_PROOF_REQUIRED'
const CLEAR_PROOF_OF_PURCHASE = 'CLEAR_PROOF_OF_PURCHASE'
const UPDATE_SURVEY_FIELD_DATA_SUCCESS = 'CLAIM_UPDATE_SURVEY_FIELD_DATA_SUCCESS'
const UPDATE_SURVEY_FIELD_RESPONSE = 'UPDATE_SURVEY_FIELD_RESPONSE'
const UPDATE_SURVEY_FIELD_DATA_FAILURE = 'CLAIM_UPDATE_SURVEY_FIELD_DATA_FAILURE'
const CHECK_SURVEY_COMPLETE_SUCCESS = 'CLAIM_CHECK_SURVEY_COMPLETE_SUCCESS'
const LOG_REVEAL_KEY_SUCCESS = 'CLAIM_LOG_REVEAL_KEY_SUCCESS'
const LOG_REVEAL_KEY_FAILURE = 'CLAIM_LOG_REVEAL_KEY_FAILURE'

export default {
  CLAIM_COUPON_REQUEST,
  CLAIM_COUPON_SUCCESS,
  CLAIM_COUPON_FAILURE,
  CLAIM_TOKEN_REQUEST,
  CLAIM_TOKEN_SUCCESS,
  CLAIM_TOKEN_FAILURE,
  CLAIM_COUPON_PROOF_REQUIRED,
  CLAIM_TOKEN_PROOF_REQUIRED,
  CLEAR_PROOF_OF_PURCHASE,
  ADD_SELECTED_CONTENT,
  ADD_SELECTED_CONTENT_FAILURE,
  ADD_SURVEY,
  REMOVE_SELECTED_CONTENT,
  GET_PROMOTION_REQUEST,
  GET_PROMOTION_SUCCESS,
  GET_PROMOTION_FAILURE,
  GET_SURVEY_REQUEST,
  GET_SURVEY_SUCCESS,
  GET_SURVEY_FAILURE,
  SET_ACTIVE_PROMOTION_STEP,
  PREVIOUS_CLAIM_STATE,
  NEXT_CLAIM_STATE,
  CLAIM_SUCCESS,
  CLAIM_FAILURE,
  CLEAR_REDEEM_STATE,
  TOGGLE_CONFIRM,
  SET_SELECT_STATE,
  UPDATE_SURVEY_FIELD_DATA_SUCCESS,
  UPDATE_SURVEY_FIELD_RESPONSE,
  UPDATE_SURVEY_FIELD_DATA_FAILURE,
  CHECK_SURVEY_COMPLETE_SUCCESS,
  LOG_REVEAL_KEY_SUCCESS,
  LOG_REVEAL_KEY_FAILURE,
}
